import { React, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom"; // Hooks do React Router
import projetosData from "../data/projetosGerais.json"; // JSON com todos os projetos
import Card from "../components/Card/Card"; // Componente de exibição de projeto resumido

function Detalhes() {

  const containerRef = useRef(null);


  // 🔹 Pega o id do projeto que está na URL
  const { id } = useParams();

  // 🔹 Cria função para navegar entre páginas
  const navigate = useNavigate();

  // 🔹 Converte o id da URL para número
  const projetoId = Number(id);

  // 🔹 Busca o projeto correspondente no JSON
  const projeto = projetosData.find((p) => p.id === projetoId);

  // 🔹 Força scroll para o topo ao abrir a página de detalhes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔹 Se o projeto não existir, mostra mensagem de erro e botão de voltar
  if (!projeto) {
    return (
      <div style={{ padding: 24 }}>
        <p>Projeto não encontrado.</p>
        <button onClick={() => navigate(-1)}>Voltar</button>
      </div>
    );
  }

  // 🔹 Extrai informações de mídia do projeto
  const { apresentacao } = projeto;

  // 🔹 Pega a primeira tag do projeto (usada para sugerir projetos relacionados)
  const mainTag = projeto.tags && projeto.tags[0];

  // 🔹 Filtra projetos relacionados (mesma tag, diferente do atual) e limita a 4
  const relacionado = projetosData
    .filter((p) => p.id !== projetoId && p.tags.includes(mainTag))
    .slice(0, 4);

  return (
    <main className="detalhes" style={{ padding: 20 }}>

      {/* 🔹 Botão para voltar à página anterior */}
      <button className="voltar" onClick={() => navigate(-1)}>← Voltar</button>

      {/* 🔹 Card de detalhes do projeto */}
      <article className="detalhe-card" style={{ marginTop: 12 }}>
        <h1>{projeto.titulo}</h1>

        {/* 🔹 Seção de mídia do projeto */}
        <div className="detalhe-media" style={{ margin: "12px 0" }}>
          {/* Imagem */}
          {apresentacao.tipo === "imagem" && (
            <img
              src={apresentacao.arquivo}
              alt={projeto.titulo}
              style={{ width: "100%", maxHeight: 520, objectFit: "cover" }}
            />
          )}

          {/* Vídeo */}
          {apresentacao.tipo === "video" && (
            <video controls style={{ width: "100%", maxHeight: 520 }}>
              <source src={apresentacao.arquivo} type="video/mp4" />
              Seu navegador não suporta o elemento de vídeo.
            </video>
          )}

          {/* Vídeo do YouTube */}
          {apresentacao.tipo === "youtube" && (
            <iframe
              title={projeto.titulo}
              src={apresentacao.url}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ width: "100%", height: 520 }}
            />
          )}
        </div>

        {/* 🔹 Descrição ou informação adicional do projeto */}
        <div className="detalhe-info" style={{ marginBottom: 12 }}>
          <p>{projeto.info || projeto.descricao}</p>
        </div>

        {/* 🔹 Tags do projeto */}
        <div className="detalhe-tags" style={{ marginBottom: 12 }}>
          {projeto.tags.map((t) => (
            <span key={t} className="card-tag" style={{ marginRight: 8 }}>
              {t}
            </span>
          ))}
        </div>

        {/* 🔹 Links úteis: download de vídeo ou abrir YouTube */}
        <div className="detalhe-links" style={{ marginBottom: 24 }}>
          {apresentacao.tipo === "video" && apresentacao.arquivo && (
            <a href={apresentacao.arquivo} download>Baixar vídeo</a>
          )}
          {apresentacao.tipo === "youtube" && apresentacao.url && (
            <a
              href={apresentacao.url.replace("/embed/", "/watch?v=")}
              target="_blank"
              rel="noreferrer"
            >
              Abrir no YouTube
            </a>
          )}
        </div>
      </article>

      {/* 🔹 Se houver projetos relacionados, mostra uma seção com cards */}
      {relacionado.length > 0 && (
        <section style={{ marginTop: 24, position: "relative" }}>
          <h2>Projetos relacionados</h2>

          {/* Botão de rolagem para esquerda */}
          <button
            onClick={() => containerRef.current.scrollBy({ left: -300, behavior: "smooth" })}
            style={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              background: "#fff",
              border: "1px solid #ccc",
              borderRadius: "50%",
              width: 36,
              height: 36,
              cursor: "pointer",
            }}
          >
            ◀
          </button>

          {/* Botão de rolagem para direita */}
          <button
            onClick={() => containerRef.current.scrollBy({ left: 300, behavior: "smooth" })}
            style={{
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              background: "#fff",
              border: "1px solid #ccc",
              borderRadius: "50%",
              width: 36,
              height: 36,
              cursor: "pointer",
            }}
          >
            ▶
          </button>

          <div
            ref={containerRef}
            className="cards-container"
            style={{
              display: "flex",
              gap: 12,
              overflowX: "auto",
              scrollBehavior: "smooth",
              padding: "12px 40px", // espaço para as setas
            }}
          >
            {relacionado.map((p) => (
              <Card
                key={p.id}
                projeto={p}
                onClick={(id) => navigate(`/projeto/${id}`)}
                style={{ flex: "0 0 auto", width: 280 }}
              />
            ))}
          </div>
        </section>
      )}
    </main>
  );
}

export default Detalhes;
